<template>
    <div>
        <agile :navButtons=false>
            <img class="slide" src="http://www.shengjia-resin.com/temp/1.jpg" />
            <img class="slide" src="http://www.shengjia-resin.com/temp/2.jpg" />
            <img class="slide" src="http://www.shengjia-resin.com/temp/3.jpg" />
        </agile>
        <div class="home-grid">
            <div class="home-grid-about">
                <h3>关于盛嘉</h3>
                <agile :navButtons=false>
                    <img class="slide2" src="http://www.shengjia-resin.com/temp/1.jpg" />
                    <img class="slide2" src="http://www.shengjia-resin.com/temp/2.jpg" />
                    <img class="slide2" src="http://www.shengjia-resin.com/temp/3.jpg" />
                </agile>
                <div v-html="companyContent"></div>
            </div>
            <div class="home-grid-news">
                <div class="home-grid-title">
                    <h3>通知公告</h3>
                    <router-link to="/announcement">MORE</router-link>
                </div>
                <ul class="news-list">
                    <li v-for="(n, index) in news" :key="index">
                        <div class="news-cal">
                            <div class="news-cal-day">{{n.date}}</div>
                            <div class="news-cal-month">{{n.month}}</div>
                        </div>
                        <!--<a :href="n.link">{{n.title}}</a>-->
                        <a href="#" @click="openwith(n.link)">{{n.title}}</a>
                    </li>
                </ul>
            </div>
            <div class="home-grid-products">
                <div class="home-grid-title">
                    <h3>我们的产品</h3>
                    <router-link to="/product">MORE</router-link>
                </div>
                <ul class="product-list">
                    <li v-for="(p, index) in products" :key="index">
                        <router-link :to="/product/+p.name">
                            <img :src="p.imgurl" :alt="p.name">
                            <div class="product-list-item">{{p.name}}</div>
                        </router-link>
                    </li>
                </ul>
            </div>
        </div>
    </div>
</template>

<script>
    import qs from 'qs'
    import {
        VueAgile
    } from 'vue-agile'

    export default {
        name: 'Home',
        components: {
            agile: VueAgile
        },
        data() {
            return {
                companyContent: '',
                companyDatas: {},
                companyType: '关于盛嘉',
                newsDatas: [],
                newsType: '通知公告',
                news: [],
                productData: [],
                products: [],
            }
        },
        created() {
            this.loadCompany();
            this.loadNews();
            this.loadProduct();
        },
        methods: {
            loadCompany() {
                this.$axios.post('/findCompanyByType', qs.stringify({companyType:this.companyType})).then(res => {
                    this.companyDatas = res.data;
                    if (this.companyDatas != null) {
                        this.companyContent = this.companyDatas.content;
                    }
                }).catch(res => {
                    alert("公司介绍数据获取失败")
                })
            },
            loadNews() {
                let params = {
                    newsType: this.newsType,
                };
                this.$axios.post('/findNewsList', qs.stringify(params)).then(res => {
                    this.newsDatas = res.data;
                    if(this.newsDatas != null && this.newsDatas.length > 0) {
                        for (let i=0;i<this.newsDatas.length;i++) {
                            let timeData = new Date(this.newsDatas[i].timestamp).toDateString();
                            let monthData = timeData.substring(4,7);
                            let dateData = timeData.substring(8,10);
                            let content = this.newsDatas[i].content;
                            let urls = content.split("href=\"");
                            let url = urls[1].split(".pdf");
                            let href = url[0]+'.pdf';
                            let newspay = {
                                date: dateData,
                                month: monthData,
                                title: this.newsDatas[i].title,
                                link: href
                            }
                            this.news.push(newspay)
                            if (i==1){
                                break;
                            }
                        }
                    }
                }).catch(res => {
                    alert("新闻数据获取失败")
                })
            },
            loadProduct() {
                this.$axios.post('/findProductTypeAll').then(res => {
                    this.productData = res.data;
                    if (this.productData != null && this.productData.length > 0) {
                        for (let i=0;i<this.productData.length;i++) {
                            this.products.push(this.productData[i])
                            if (i==5) {
                                break;
                            }
                        }
                    }
                }).catch(res => {
                    alert("产品数据获取失败")
                })
            },
            openwith(val){
                window.open(val)
            }
        }
    }
</script>

<style lang="less">
    .home-grid {
        max-width: 1024px;
        margin: 0 auto;
        display: grid;
        grid-template-columns: 360px auto;

        >div {
            padding: 16px;
        }

        &-title {
            display: flex;
            justify-content: space-between;
            align-items: center;

            a {
                font-size: 12px;
                color: #e4b248;
                text-decoration: underline;
            }
        }

        &-about {
            grid-row-start: 1;
            grid-row-end: 3;
            grid-column: 1;
        }

        &-news {
            grid-column: 2;
            grid-row: 1;
        }

        &-products {
            grid-column: 2;
            grid-row: 2;
        }

        h3 {
            position: relative;
            margin: 0 0 16px 0;
            padding: 16px 0;
            font-size: 16px;
            font-weight: normal;

            &::before {
                content: "";
                position: absolute;
                left: 0;
                width: 24px;
                bottom: 4px;
                height: 2px;
                background: #e4b248;
            }
        }

        p {
            color: #666;
            font-size: 13px;
            line-height: 25px;
            text-indent: 2em;
        }
    }

    .news-list {
        margin: 0;
        padding: 0;

        li {
            list-style-type: none;
            display: flex;
            padding: 16px 0;
            border-top: 1px solid #eee;

            &:first-child {
                border-top: 0;
            }

            .news-cal {
                flex-grow: 0;

                &-day {
                    position: relative;
                    background: #e4b248;
                    border-radius: 5px;
                    height: 40px;
                    line-height: 40px;
                    width: 50px;
                    font-size: 20px;
                    color: #FFF;
                    text-align: center;

                    &::before {
                        content: "";
                        position: absolute;
                        left: 0;
                        right: 0;
                        top: 50%;
                        height: 1px;
                        background: #fff;
                        opacity: .25;
                    }
                }

                &-month {
                    width: 50px;
                    font-size: 10px;
                    text-align: center;
                    color: #666;
                    padding-top: 4px;
                }
            }

            a {
                padding-left: 16px;
                flex-grow: 1;
                display: flex;
                flex-direction: column;
                justify-content: center;
                font-size: 14px;
                line-height: 1.25;
            }
        }
    }

    .product-list {
        margin: 0;
        padding: 0;
        display: flex;
        flex-wrap: wrap;

        li {
            list-style-type: none;
            width: 33%;
            overflow: hidden;
            box-sizing: border-box;

            a {
                position: relative;
                display: block;
                margin: 0 16px 16px 0;
            }

            img {
                width: 100%;
                height: 160px;
                display: block;
                object-fit: cover;
            }

            .product-list-item {
                position: absolute;
                bottom: 0;
                left: 0;
                right: 0;
                font-size: 14px;
                color: #000;
                height: 32px;
                line-height: 32px;
                background-color: rgba(255, 255, 255, .75);
                padding: 0 8px;
                transition: height .5s;
                white-space: nowrap;
                overflow: hidden;
                text-overflow: ellipsis;
            }

            &:hover .product-list-item {
                height: 48px;
            }
        }
    }

    .slide2 {
        display: block;
        height: 200px;
        object-fit: cover;
        width: 100%;
    }
</style>